import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de usuarios
 * 
 * NOTA: Los endpoints de usuarios ahora usan Python (FastAPI)
 */
const usuarioApi = {
  // Obtener todos los usuarios
  getAll: () => pythonApiClient.get('/mantenimientos/usuarios/list'),

  // Obtener usuario por ID
  getById: (id) => pythonApiClient.get(`/mantenimientos/usuarios/${id}`),

  // Crear nuevo usuario
  create: (userData) => pythonApiClient.post('/mantenimientos/usuarios', userData),

  // Actualizar usuario
  update: (id, userData) => pythonApiClient.put(`/mantenimientos/usuarios/${id}`, userData),

  // Eliminar usuario
  delete: (id) => pythonApiClient.delete(`/mantenimientos/usuarios/${id}`),

  // Obtener proyectos de un usuario
  getProyectos: (userId) => pythonApiClient.get(`/mantenimientos/usuarios/${userId}/proyectos`)
};

export default usuarioApi;
